
import React, { useState } from "react";
import { Grid, Box, Typography } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpandLessIcon from '@material-ui/icons/ExpandLess';
import Tooltip from '@material-ui/core/Tooltip';

const useStyles = makeStyles({
    container: {
        position: 'absolute',
        bottom: '32px',
        background: 'transparent',
        width: '77%',
        zIndex: 999,
        // border: 'solid 1px red',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translateX(-50%)',
        left: '50%',
        flexWrap: 'nowrap',
        "@media only screen and (max-width: 1150px)": {
            width: '80%'
        }
    },
    image: {
        width: 66
    },
    hexagon: {
        width: 66,
        height: 59
    },
    label: {
        fontSize: 14,
        fontFamily: 'Roboto, Helvetica',
        fontWeight: 500,
        "@media only screen and (max-width: 1300px)": {
            fontSize: "12px"
        },
        "@media only screen and (max-width: 1150px)": {
            fontSize: "10.5px"
        }
    },
    grid: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    box: {
        textAlign: 'center',
        display: 'flex',
        alignItems: 'center',
        flexDirection: 'column',
        cursor: 'move'
    },
    expandIcon: {
        position: 'absolute',
        bottom: '8px',
        background: 'transparent',
        width: '65%',
        zIndex: 999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transform: 'translateX(-50%)',
        left: '50%',
        backgroundColor: '#fff',
        width: 25,
        height: 25,
        borderRadius: '50%',
        cursor: 'pointer'
    }
})

export default function SystemModelSpeedDial() {

    const classes = useStyles()

    const [open, setOpen] = useState(true);

    const toggleSpeedDial = () => setOpen(prev => !prev);

    const onDragStart = (event, nodeType) => {
        //event.dataTransfer.setDragImage(document.getElementById('draggable-external_function'),50,50);
        event.dataTransfer.setData("application/reactflow", nodeType);
        event.dataTransfer.effectAllowed = "move";
    };

    const Label = ({ children }) => {
        return (
            <Typography className={classes.label}>{children}</Typography>
        )
    }

    return (
        <>
            {open &&
                <Grid container spacing={1} columns={5} id="system-model-speed-dial" className={classes.container} data-ui-tour-id='systemmodel-speeddial'>
                    <Grid item xs={3} className={classes.grid}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'external_function')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/delegate_sd.png`} className={classes.image} />
                                <Label>Delegate</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid} style={{ marginTop: 5 }}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'clusterlet')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/digitaltwin_sd.png`} className={classes.hexagon} />
                                <Label>Digital Twin</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid} style={{ marginTop: 5 }}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'analytics')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/analytics_sd.png`} className={classes.hexagon} />
                                <Label>{process.env.REACT_APP_ANALYTICS}</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'user')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/Enterprise_app_sd.png`} className={classes.image} />
                                <Label>Enterprise App</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'infer_engine')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/infer_sd.png`} className={classes.hexagon} />
                                <Label>Infer Engine</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'learn_engine')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/learn_sd.png`} className={classes.hexagon} />
                                <Label>Learn Engine</Label>
                            </Box>
                        </Tooltip>
                    </Grid>

                    <Grid item xs={3} className={classes.grid}>
                        <Tooltip title="Drag node to the screen">
                            <Box className={classes.box} onDragStart={(event) => onDragStart(event, 'generate_engine')} draggable>
                                <img src={`${process.env.PUBLIC_URL}/node_icons/generate_sd.png`} className={classes.hexagon} />
                                <Label>Generate Engine</Label>
                            </Box>
                        </Tooltip>
                    </Grid>
                </Grid>
            }

            <Tooltip title={open ? 'Close tray' : 'Open tray'}>
                <Box size='small' id='system-model-speed-dial-toggle' className={classes.expandIcon} onClick={toggleSpeedDial}>
                    {open ? <ExpandMoreIcon fontSize='small' /> : <ExpandLessIcon fontSize='small' />}
                </Box>
            </Tooltip>


        </>
    )
}